<ng-container *ngIf="modalIsActive">
  <div #modal
       (click)="handleClickEvent($event)"
       (mousedown)="handleMouseDownEvent($event)"
       (mouseup)="handleMouseUpEvent($event)"
       [attr.aria-label]="modalHeader"
       [cdkTrapFocus]="modalIsActive"
       [class.ds-modal--active]="modalIsActive"
       [class.pt-7]="isStoreHeaderShown"
       aria-modal="true"
       class="ds-modal"
       role="dialog"
  >
    <div #modalBody
         class="ds-modal__body">
      <div class="ds-modal__body__header py-4 px-5">
        <div class="ds-modal__body__header__text">
          <h4 class="ds-heading--m m-0">{{modalHeader}}</h4>
        </div>
        <div class="ds-modal__body__header__close">
          <button #modalCloseButton
                  (click)="closeModal()"
                  aria-label="Close Modal"
                  class="ds-modal__body__header__close__button p-0"
          >
            <em class="ds-icon ds-icon--close ds-modal__body__header__close__button__icon"></em>
          </button>
        </div>
      </div>
      <div class="ds-modal__body__content">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</ng-container>
